module.exports = __webpack_public_path__ + "img/cooperate_yh_07@2x.456ade36.png";